/**
  ID generator
*/

import { v4 } from 'uuid'

export default v4
